import { LoadingButton } from '@mui/lab'
import { Button } from '@mui/material'
import React, { forwardRef } from 'react'
import SendIcon from '@mui/icons-material/Send';
import { ENV_COLORS } from '../../styles/theme';

const ThemeButton = (props, _ref) => {
  const { text, loading = false, isDisabled = false, ...buttonProps } = props
  return loading ? (
    <LoadingButton
      {...buttonProps}
      endIcon={<SendIcon />}
      loading={loading}
      loadingPosition="end"
      variant="contained"
    >
      {text}
    </LoadingButton>
  ) : (
    <Button {...buttonProps}
      disabled={isDisabled}
      style={{
        background: ENV_COLORS[process.env.REACT_APP_ENV] || ENV_COLORS.default,
        color: '#ffff'
      }}
    >{text}</Button>
  )
}

export default forwardRef(ThemeButton)
